import React from 'react';

import * as S from './OfferCarouselLoader.styles';

const OfferCarouselLoader = () => {
  return (
    <S.BannerLoaderContainer>
      <S.BannerImageLoader></S.BannerImageLoader>
      <S.BannerLoaderOuterWrap>
        <S.BannerLoaderInnerWrap>
          <S.OfferImageLoader></S.OfferImageLoader>
          <S.OfferDetailsLoader></S.OfferDetailsLoader>
          <S.OfferValidLoader></S.OfferValidLoader>
        </S.BannerLoaderInnerWrap>
        <S.BannerLoaderInnerWrap>
          <S.OfferImageLoader></S.OfferImageLoader>
          <S.OfferDetailsLoader></S.OfferDetailsLoader>
          <S.OfferValidLoader></S.OfferValidLoader>
        </S.BannerLoaderInnerWrap>
      </S.BannerLoaderOuterWrap>
    </S.BannerLoaderContainer>
  );
};

export default OfferCarouselLoader;
